// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/header/styles/Header.scss
// module id = 1220
// module chunks = 0